import React from 'react';
import { motion } from 'framer-motion';
import styles from './ClaySwitch.module.css';

interface ClaySwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id?: string;
  disabled?: boolean;
}

export function ClaySwitch({ checked, onChange, label, id, disabled }: ClaySwitchProps) {
  return (
    <label
      htmlFor={id}
      className={[styles['label'], disabled ? styles['label-disabled'] : ''].filter(Boolean).join(' ')}
    >
      {label && (
        <span className={styles['label-text']}>
          {label}
        </span>
      )}
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={[styles['track'], checked ? styles['track-checked'] : ''].filter(Boolean).join(' ')}
      >
        <motion.span
          className={styles['thumb']}
          animate={{ left: checked ? '18px' : '2px' }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        />
      </button>
    </label>
  );
}
